// extracted by mini-css-extract-plugin
module.exports = {"container":"photo_container__GitMo","small":"photo_small__71ozu","medium":"photo_medium__3DzFn","large":"photo_large__BLGHv","circle":"photo_circle__1tKQt"};